const meridian=[
    
{
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/478877522.jpg?k=c5dce3bc9db07f5fcd9e5cbd32640ac0d1a85676477e528ed741ab6cb00d7621&o=',
      alt: 'Meridian by Daan',
    },
    {
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/478794508.jpg?k=5bbd71c691ec0976ba87e28f47f15dbf7c26668d5efdbc79dfc724a92359e6cb&o=',
   alt: 'Meridian by Daan',
    },
    {
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/478863727.jpg?k=91a9e18a15a39f7f251a53b968426d9359c5dc80f913219a7f9cd2f845434533&o=',
    alt: 'Meridian by Daan',
    },
    {
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/478794448.jpg?k=fd6f7e27961037db602e6052b37f46bcdeb74f9a7dcb800d270e5694deba297c&o=',
      alt: 'Meridian by Daan',
    },
    {
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/478864685.jpg?k=739e77084ba58363f23e58c72a8fdb2fa660964e511cf892dfbd54e1ec94ecae&o=',
    alt: 'Meridian by Daan',
    }, {
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/478863703.jpg?k=b728cbe39375e1289b7c9ed690b385da921b70a0eabd1438c151fd2524cf369c&o=',
     alt: 'Meridian by Daan',
    }, 

]

export default meridian;